/**
 * Relevance of the job a list card opened — read back by the job-details hero badge.
 *
 * Mirrors Flutter `prefs.setString('relevanceData', …)` (JobListViewBloc / WebHomeBloc /
 * ExtractedResumeBloc / WebViewJobsBloc _OnClickSetRelevanceData) and the read in
 * JobDetailsViewBloc._GetJobDetails. SharedPreferences is localStorage on web, so the value
 * reaches the job page that the card opens in a new tab.
 */

const RELEVANCE_DATA_KEY = 'relevanceData';

/** Store `{ displayId, relevance }` for the job that is about to open. */
export function setRelevanceData(entity: {
  displayId?: string;
  relevance?: Record<string, unknown> | null;
}): void {
  localStorage.setItem(
    RELEVANCE_DATA_KEY,
    JSON.stringify({ displayId: entity.displayId ?? '', relevance: entity.relevance ?? null }),
  );
}

/** The stored relevance when it belongs to `displayId` and isn't empty, else null. */
export function getRelevanceData(displayId: string | undefined): Record<string, unknown> | null {
  try {
    const json = localStorage.getItem(RELEVANCE_DATA_KEY);
    if (!json) return null;
    const decoded = JSON.parse(json) as { displayId?: unknown; relevance?: unknown };
    if (decoded.displayId !== displayId) return null;
    const relevance = decoded.relevance;
    if (!relevance || typeof relevance !== 'object' || Object.keys(relevance).length === 0) {
      return null;
    }
    return relevance as Record<string, unknown>;
  } catch {
    return null;
  }
}
